import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-1': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20college%20student%20getting%20hair%20styled%20in%20elegant%20salon%2C%20warm%20rose%20and%20cream%20interior%2C%20soft%20natural%20lighting%2C%20minimalist%20design%2C%20editorial%20photography%20with%20clean%20aesthetic&width=600&height=400&seq=article-1&orientation=landscape',
  'article-2': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20student%20doing%20skincare%20routine%20with%20serum%20in%20bright%20clean%20bathroom%2C%20warm%20soft%20lighting%2C%20cream%20tones%2C%20minimalist%20aesthetic%2C%20editorial%20photography&width=600&height=400&seq=article-2&orientation=landscape',
  'article-3': 'https://readdy.ai/api/search-image?query=Beautiful%20young%20asian%20female%20college%20student%20with%20trendy%20wavy%20hairstyle%20on%20university%20campus%2C%20autumn%20vibes%2C%20warm%20tones%2C%20editorial%20fashion%20photography%2C%20clean%20soft%20lighting&width=600&height=400&seq=article-3&orientation=landscape',
};

export default function FeaturedArticles() {
  const featured = articles.slice(0, 3);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            美丽资讯
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            最懂女大学生的美妆护肤干货分享
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/articles/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-200 hover:bg-background-200/50"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={articleImages[article.id] || ''}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/articles"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer transition-colors whitespace-nowrap"
          >
            阅读更多文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}